<template>
  <div class="py-8 px-12">
    Продукты
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { formatPhone } from "@/mixins/formatPhone";

export default {
  mixins: [formatPhone],

  computed: {
    ...mapState("meeting", ["accountOpenStep"]),
    step: {
      get() {
        return this.accountOpenStep;
      },
      set(v) {
        this.setAccountOpenStep(v);
      }
    }
  },

  methods: {
    ...mapMutations("meeting", ["setAccountOpenStep"])
  }
};
</script>
